import * as yup from "yup";

export const validationSchema = yup.object().shape({
  descr: yup.string().required("دلیل تغییر وضعیت..."),
  last_state: yup.string().required("وضعیت..."),
});

export const initialValue = {
  descr: "",
  last_state: "",
};
